import { Expression } from '@kaiizen/kai-calc';

// *************************************************************************
// Parser Cache
// *************************************************************************
type ExpressionWithDependencies = { expression: string; parsedExpression: Expression; dependencies: string[]; functions: string[] };
const parserCache = new Map<string, ExpressionWithDependencies>();

export const getCachedParsedExpression = (expression: string): ExpressionWithDependencies => {
  if (parserCache.has(expression)) return parserCache.get(expression)!;
  const parsedExpression = new Expression(expression);
  const value = { expression, parsedExpression, dependencies: parsedExpression.parameters, functions: parsedExpression.functions };
  parserCache.set(expression, value);
  return value;
};
